import React from 'react'
import styled from 'styled-components/macro'
import ReactGA from 'react-ga'
import { getGelTokens } from '@tal-gel/theming'

import Overline from '../Typography/Overline'
import arrow from './arrow-corner.svg'
import facebook from './facebook.svg'
import twitter from './twitter.svg'
import linkedin from './linkedin.svg'

const getDate = () => new Date().getFullYear()

const Component = styled.div``

const Links = styled.div`
  background-color: ${() => getGelTokens().brand.brandColorPrimary2};
  padding: 48px 40px;

  @media only screen and (min-width: 576px) {
    padding: 106px 40px;

    display: flex;
    justify-content: center;
  }
`

const LinksInnerWrapper = styled.div`
  & > div:not(:last-child) {
    margin-bottom: 40px;
  }

  @media only screen and (min-width: 576px) {
    width: 100%;
    max-width: 1032px;

    display: flex;
    justify-content: space-between;

    & > div:not(:last-child) {
      margin-bottom: 0;
    }

    & > div {
      flex: 1;
    }

    & > div:last-child {
      flex: 2;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
  }
`

const Additions = styled.div`
  font-family: 'Pluto Sans Condensed', Arial, sans-serif;
  background-color: ${() => getGelTokens().brand.brandColorPrimary2T90};
  color: ${() => getGelTokens().brand.brandColorGrayT40};
  padding: 29px 40px;
  font-size: 15px;
  line-height: 20px;

  @media only screen and (min-width: 576px) {
    display: flex;
    justify-content: center;
  }
`

const AdditionsInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 576px) {
    width: 100%;
    max-width: 1032px;

    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

const LinksHolder = styled.div``

const Link = styled(ReactGA.OutboundLink)`
  font-size: 18px;
  font-family: 'Pluto Sans Condensed', Arial, sans-serif;
  color: ${() => getGelTokens().brand.brandColorGrayT20};
  text-decoration: none;
  display: inline-flex;
  align-items: center;

  &:hover {
    cursor: pointer;
    filter: brightness(110%);
    text-decoration: underline;
  }

  &:focus,
  &:visited,
  &:active {
    color: ${() => getGelTokens().brand.brandColorGrayT20};
    text-decoration: none;
  }
`

const Icon = styled.img`
  margin-left: 12px;
`

const SocialIcons = styled.div`
  display: flex;
  align-items: center;

  & > a:not(:last-of-type) {
    margin-right: 18px;
  }
`

const SocialLink = styled(ReactGA.OutboundLink)`
  &:hover {
    cursor: pointer;
    filter: brightness(110%);
  }
`

const SocialIcon = styled.img`
  width: 28px;
  height: 28px;
`

const Terms = styled.a`
  color: ${() => getGelTokens().brand.brandColorGrayT40};
  text-decoration: none;

  &:hover {
    cursor: pointer;
    filter: brightness(110%);
    text-decoration: underline;
  }

  &:focus,
  &:visited,
  &:active {
    color: ${() => getGelTokens().brand.brandColorGrayT40};
    text-decoration: none;
  }

  @media only screen and (min-width: 576px) {
    order: 2;
  }
`

const Copyright = styled.p`
  max-width: 208;
  margin-top: 60px;
  order: 1;

  @media only screen and (min-width: 576px) {
    margin-top: 0;
    max-width: none;
  }
`
const Footer = ({ demo }) => (
  <Component>
    <Links>
      <LinksInnerWrapper>
        <LinksHolder>
          <Overline white mb={3.5}>
            TAL
          </Overline>
          <Link
            href='https://www.tal.com.au/'
            target='_blank'
            rel='noopener noreferrer'
            eventLabel='https://www.tal.com.au/'
            to='https://www.tal.com.au/'
          >
            TAL website
            <Icon src={arrow} alt='TAL' />
          </Link>
        </LinksHolder>
        {!demo && (
          <LinksHolder>
            <Overline white mb={3.5}>
              CBus
            </Overline>
            <Link
              href='https://www.cbussuper.com.au/'
              target='_blank'
              rel='noopener noreferrer'
              eventLabel='https://www.cbussuper.com.au/'
              to='https://www.cbussuper.com.au/'
            >
              CBus website
              <Icon src={arrow} alt='Cbus' />
            </Link>
          </LinksHolder>
        )}
        <LinksHolder>
          <Overline white mb={3.5}>
            Keep in touch
          </Overline>
          <SocialIcons>
            <SocialLink
              href='https://www.facebook.com/TALaustralia'
              target='_blank'
              rel='noopener noreferrer'
              eventLabel='https://www.facebook.com/TALaustralia'
              to='https://www.facebook.com/TALaustralia'
            >
              <SocialIcon src={facebook} alt='Facebook' />
            </SocialLink>
            <SocialLink
              href='https://twitter.com/talaustralia'
              target='_blank'
              rel='noopener noreferrer'
              eventLabel='https://twitter.com/talaustralia'
              to='https://twitter.com/talaustralia'
            >
              <SocialIcon src={twitter} alt='Twitter' />
            </SocialLink>
            <SocialLink
              href='https://www.linkedin.com/company/talaustralia/'
              target='_blank'
              rel='noopener noreferrer'
              eventLabel='https://www.linkedin.com/company/talaustralia/'
              to='https://www.linkedin.com/company/talaustralia/'
            >
              <SocialIcon src={linkedin} alt='LinkedIn' />
            </SocialLink>
          </SocialIcons>
        </LinksHolder>
      </LinksInnerWrapper>
    </Links>
    <Additions>
      <AdditionsInnerWrapper>
        {!demo && (
          <Copyright>
            © {getDate()} Cbus Super. All rights reserved. Cbus ABN 75 493 363
            262.
          </Copyright>
        )}
        <Terms>Website terms and conditions</Terms>
      </AdditionsInnerWrapper>
    </Additions>
  </Component>
)

export default Footer
